import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import AdminDashboard from "../views/AdminDashboard.vue";
import UserDashboard from "../views/UserDashboard.vue";

const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", name: "Login", component: LoginView },
  { path: "/admin", name: "AdminDashboard", component: AdminDashboard },
  { path: "/user", name: "UserDashboard", component: UserDashboard },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (to.path === "/login") return next();
  if (!user) return next("/login");
  if (to.path === "/admin" && user.role !== "superadmin") return next("/user");
  if (to.path === "/user" && user.role !== "normal") return next("/admin");
  next();
});

export default router;
